import React from "react";
import moment from "moment";
import {
  getField,
  deserializeField,
  padZerosToString,
} from "../../../../util/DynamicItemUtils";

export default function DeniedIssuerAuditClient({ item }: any) {
  const dateParsingFormat = "YYYY-MM-DDTHH:mm:ssZ";
  const dateDisplayFormat = "MMMM D, YYYY";

  const filingAuditYear = getField(item, "filingaudityear");
  const filingAuditYearFormatted =
    filingAuditYear &&
    filingAuditYear.replace("+000000000000", "").replace(".0000", "");
  const issuerName = getField(item, "issuername");
  const issuerCik = getField(item, "issuercik");
  const filingId = getField(item, "filingid");
  const originalFirmFormId = getField(item, "originalfirmformid");
  const otherAccountingFirmParticipation = deserializeField(
    item,
    "auditnotdividedpercent"
  );
  const useRangeIndicator = getField(item, "userangeindicator") === "True";

  const title = `${filingAuditYearFormatted}${
    filingAuditYear ? ` ${issuerName}` : `${issuerName}`
  }${issuerCik ? ` CIK (${padZerosToString(issuerCik)})` : ""}`;
  const titleHref =
    filingId &&
    originalFirmFormId &&
    `/resources/auditorsearch/form-ap-filing?filingid=${filingId}&originalfirmformid=${originalFirmFormId}`;
  return (
    <div className="registered-firms">
      <div>
        <h3 className="break-word">
          {titleHref ? <a href={titleHref}>{title}</a> : <div>{title}</div>}
        </h3>
        {getField(item, "firmname") && (
          <p>
            <strong>Firm Name:</strong>
            {` ${getField(item, "firmname")}`}
          </p>
        )}
        {getField(item, "firmcountrymasked") && (
          <p>
            <strong>Firm Location:</strong>
            {` ${getField(item, "firmcountrymasked")}`}
          </p>
        )}
        {getField(item, "filingdate") && (
          <p>
            <strong>Filing Date:</strong>
            {` ${moment(getField(item, "filingdate"), dateParsingFormat).format(
              dateDisplayFormat
            )}`}
          </p>
        )}
        {otherAccountingFirmParticipation && (
          <>
            <div>
              <strong>Participation of Other Accounting Firms:</strong>
            </div>
            <ul className="other-participating-firms-list">
              {otherAccountingFirmParticipation[0].map((firm) => {
                return (
                  <li>{`${firm.FirmName}${
                    firm.FirmID ? ` (${firm.FirmID})` : ""
                  } – ${firm.Country} – ${
                    useRangeIndicator ? firm.Range : `${firm.Percentage}%`
                  }`}</li>
                );
              })}
            </ul>
          </>
        )}
      </div>
      {titleHref ? (
        <div className="registered-firms__links-container">
          <a className="btn btn--primary" href={titleHref}>
            View Form AP
          </a>
        </div>
      ) : null}
    </div>
  );
}
